import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';

const SidebarContent = (props) => {
  const propTypes = {
    changeToDark: PropTypes.func.isRequired,
    changeToLight: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
  };



  const hideSidebar = () => {
    const { onClick } = props;
    onClick();
  };


  const getIconData = (menu) => {
    if (menu.iconType === 'icon' && menu.iconName) {
      return { icon: menu.iconName, iconType: 'icon' };
    }
    const letters = menu.iconLetters || (menu.displayTitle ? menu.displayTitle.substring(0, 2) : '');
    return { icon: letters, iconType: 'letters' };
  };


  const { menuList } = props;


  return (
    <div className="sidebar__content">
      <ul className="sidebar__block">
        {menuList && menuList.length > 0
          ? menuList.map((item, index) => {
            const itemIconData = getIconData(item);
            if (item.submenus && item.submenus.length > 0) {
              return (
                <SidebarCategory
                  key={index}
                  title={item.displayTitle === 'Settings' ? 'Settings Menu' : item.displayTitle}
                  icon={itemIconData.icon}
                  iconType={itemIconData.iconType}
                >

                  {item.submenus.map((sitem, sindex) => {
                    const sitemIconData = getIconData(sitem);
                    return (

                      <SidebarLink key={sindex}
                        title={sitem.displayTitle}
                        icon={sitemIconData.icon}
                        onClick={hideSidebar}
                        iconType={sitemIconData.iconType}
                        route={sitem.route}
                        isSubmenu={true}
                      />
                    );
                  })}
                </SidebarCategory>
              );
            }
            return (
              <SidebarLink
                key={index}
                icon={itemIconData.icon}
                title={item.displayTitle}
                route={item.route}
                onClick={hideSidebar}
                iconType={itemIconData.iconType}
                isSubmenu={false}
              />
            );
          })
          : null}
      </ul>
    </div>
  );
};


export default SidebarContent;

